var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Usage Report")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { "aria-label": "Close", type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body p-0" }, [
        _setup.loading
          ? _c("div", { staticClass: "text-center p-4" }, [
              _c("div", {
                staticClass:
                  "spinner-border spinner-border-sm text-primary me-2",
                attrs: { role: "status" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v("Fetching usage data..."),
              ]),
            ])
          : _setup.contentData.length === 0
          ? _c("div", { staticClass: "text-center p-4 text-muted" }, [
              _vm._v(
                "\n                This content type is not currently in use.\n            "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "list-group list-group-flush" },
              _vm._l(_setup.contentData, function (content, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass:
                      "list-group-item d-flex align-items-center py-2",
                  },
                  [
                    _c("div", { staticClass: "flex-fill text-truncate pe-2" }, [
                      _c("span", { staticClass: "fw-bold" }, [
                        _vm._v(_vm._s(content.title)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-group shadow-sm" },
                      [
                        _c(
                          _setup.Button,
                          {
                            staticClass: "btn-sm btn-light",
                            class: {
                              "disabled opacity-0": !content.pageContentId,
                            },
                            attrs: { title: "Locate in Site Tree" },
                            nativeOn: {
                              click: function ($event) {
                                return _setup.goToSiteTree(
                                  content.pageContentId
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "bi-diagram-3-fill" })]
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.Button,
                          {
                            staticClass: "btn-sm btn-light",
                            attrs: { title: "Edit Content" },
                            nativeOn: {
                              click: function ($event) {
                                return _setup.goToContent(content.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "bi-pencil-square" })]
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.Button,
                          {
                            staticClass: "btn-sm btn-light",
                            class: {
                              "disabled opacity-0": !content.pageContentId,
                            },
                            attrs: { title: "View on Website" },
                            nativeOn: {
                              click: function ($event) {
                                return _setup.openWebsitePreview(
                                  content.pageContentId
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "bi-globe" })]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }